/**
 * @module web/store
 * @private
 */

import { cache } from "../persistence/cache";

let localUserId = null;

/**
 * Update the session globalUserId with the given newUserId. This id will be saved in memory and also in a local cache for a
 * period of 4 hours.
 * @param {String} newUserId - A globalUserId obtained from a user data object through a backend call.
 */
const update = function(newUserId) {
  localUserId = newUserId;
};

/**
 * Returns the current session globalUserId, if any. The id will be searched in memory first and local cache as second
 * option.
 * @returns {string} - A found globalUserId or null if none memory nor cache have a valid one.
 */
const get = async function() {
  let cachedUserId = null;
  if (this.localCache && this.localCache.auth) {
    cachedUserId = await cache.get("user", { database: "auth" });
  }
  if (!localUserId && cachedUserId && cachedUserId.globalUserId) {
    localUserId = cachedUserId.globalUserId;
  }
  return localUserId;
};

export default { update, get };
